module.exports = __webpack_public_path__ + "static/media/16_plantilla_cuadrada_combo_simple_cp_stills_pet_500_pwd_frutas_trop.070d87f0.png";